<script>
import { Popup, Button } from "vant";
import elements from "./elements";

export default {
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    ...elements,
  },
  props: {
    title: {
      type: String,
      default: "筛选",
    },
    styles: {
      type: Object,
      default: () => {},
    },
    content: {
      type: Array,
      default: () => [],
    },
    submit: Function,
  },
  data() {
    return {
      show: false,
      data: {},
    };
  },
  created() {},
  mounted() {
    this.show = true;
  },
  methods: {
    renderItem(obj, h) {
      const that = this;
      const name = obj.type;
      const option = {
        ref: obj.name,
        props: {
          ...obj.props,
          data: obj.data,
          value: that.data[obj.name],
        },
        on: {
          update(e) {
            that.data[obj.name] = e;
          },
        },
      };
      return h(name, option);
    },
    handleClose() {
      this.show = false;
      this.$emit("close");
    },
    handleSubmit() {
      this.show = false;
      this.$emit("submit", this.data);
    },
    handleReset() {
      this.data = {};
      //重置组件值
      for (let i = 0; i < this.content.length; i++) {
        const item = this.content[i];
        if (this.$refs[item.name]) {
          this.$refs[item.name].setValue("");
        }
      }
    },
  },
  render(h) {
    const popupOption = {
      props: {
        position: "right",
        closeable: true,
      },
      style: {
        height: "100%",
        width: "80%",
        ...this.styles,
      },
      on: {
        close: () => {
          this.handleClose();
        },
      },
    };

    const items = this.content.map(item => {
      const itemContent = this.renderItem(item, h);
      return (
        <div class="search-item">
          <div class="search-item-label">{item.label}</div>
          <div class="search-item-content">{itemContent}</div>
        </div>
      );
    });

    const content = <div class="content">{items}</div>;
    return (
      <van-popup vModel={this.show} {...popupOption}>
        <div class="search-popup">
          <div class="title">{this.title}</div>
          {content}
          <div class="action">
            <van-button
              class="action-item"
              block
              type="default"
              {...{ on: { click: this.handleReset } }}
            >
              重置
            </van-button>
            <van-button
              class="action-item"
              block
              type="info"
              {...{ on: { click: this.handleSubmit } }}
            >
              确认
            </van-button>
          </div>
        </div>
      </van-popup>
    );
  },
};
</script>

<style lang="less" scoped>
.search-popup {
  font-size: 14px;
  position: relative;
  height: 100%;
  padding-bottom: 44px;
  .title {
    font-size: 16px;
    line-height: 50px;
    padding-left: 16px;
    border-bottom: 1px solid #f1f1f1;
  }
  .search-item {
    padding: 16px;
    border-bottom: 1px solid #f1f1f1;
    .search-item-label {
      margin-bottom: 10px;
      color: #888;
    }
  }
  .action {
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    .action-item {
      flex: 1;
    }
  }
}
.content {
  height: calc(100vh - 100px);
  overflow-y: auto;
  margin-bottom: 50px;
}
</style>
